import React from 'react';
import FlowRendererField from 'conversie-flow-bundle/assets/js/components/flow/renderers/FlowRendererField';

export default function ConversionComponentTradeInVehicle({ component, path, id, ...passProps }) {
    return (
        <>
            <FlowRendererField
                component={component}
                fields={component?.fields}
                path={`${path}.fields`}
                id={`${id}.fields`}
                {...passProps}
            />
            {component?.metadata?.brand &&
            <div className="col-12">
                <div className="bg-light border-radius-2 p-2">
                    <div className="row gutters-4">
                        {component?.metadata?.vehicle_image &&
                        <div className="col-auto">
                            <img
                                className="border-radius-2"
                                src={component.metadata.vehicle_image}
                                width="113"
                                height="71"
                                alt=""
                            />
                        </div>
                        }
                        {component?.metadata?.brand && component?.metadata?.model &&
                        <div className="col-auto d-flex flex-column justify-content-center">
                            <p className="text-muted--60 mb-0 text--sm">Uw auto</p>
                            <span className="text--lg">{component.metadata.brand} {component.metadata.model}</span>
                        </div>
                        }
                    </div>
                </div>
            </div>
            }
        </>
    );
}